import { request } from 'root/common/request';
import apiJSON from '../../common/config/config';

/**
 * 获取一键公告
 */
export function getAnnouncement(params) {
    return request({
        url: apiJSON.api.getAnnouncement,
        method: 'GET',
        params: params,
        isNeedLoading: false,
        isNeedToken: false,
        headers: {
            appId: 'wx9b3ada98e020c31b',
        },
    });
}
